// extracted by mini-css-extract-plugin
export default {"container":"questionarie_container__7aU-G","head":"questionarie_head__EDBjR","remain":"questionarie_remain__Hwosr","UnAuthor":"questionarie_UnAuthor__99sS5"};